"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
// Look up table entry:
// key => { value, word, [ next | rest ]? }
//  value: numeric value corresponding to the lookup
//  word:  string corresponding to the lookup
//  next:  a look up table if there are multiple possible values
//  rest:  the remaining portion of the word
var LookUpTable = {
  j: {
    value: 0,
    word: 'January',
    next: {
      a: {
        value: 0,
        word: 'January',
        rest: 'nuary'
      },
      u: {
        value: 5,
        word: 'June',
        next: {
          n: {
            value: 5,
            word: 'June',
            rest: 'e'
          },
          l: {
            value: 6,
            word: 'July',
            rest: 'y'
          }
        }
      }
    }
  },
  f: {
    value: 1,
    word: 'February',
    rest: 'ebruary'
  },
  m: {
    value: 2,
    word: 'March',
    next: {
      a: {
        value: 2,
        word: 'March',
        next: {
          r: {
            value: 2,
            word: 'March',
            rest: 'ch'
          },
          y: {
            value: 4,
            word: 'May'
          }
        }
      }
    }
  },
  a: {
    value: 3,
    word: 'April',
    next: {
      p: {
        value: 3,
        word: 'April',
        rest: 'ril'
      },
      u: {
        value: 7,
        word: 'August',
        rest: 'gust'
      }
    }
  },
  s: {
    value: 8,
    word: 'September',
    rest: 'eptember'
  },
  o: {
    value: 9,
    word: 'October',
    rest: 'ctober'
  },
  n: {
    value: 10,
    word: 'November',
    rest: 'ovember'
  },
  d: {
    value: 11,
    word: 'December',
    rest: 'ecember'
  }
};
var _default = LookUpTable;
exports.default = _default;